<template>
  <div class="depth-data-com">
    <div class="module">
      <div id="depth-module" class="module-body">
        <div class="group-merge-type">
          <!--{{Getter_Current_Currency}}-->
          <!-- <span>{{Getter_Current_Currency.abbreviation || '--'}}</span> -->
          <!--<span>{{decimalRetain(lastPrice, 4) || "&#45;&#45;"}} / {{Getter_Current_Currency.abbreviation || '&#45;&#45;'}}</span>-->
          <div>
            <v-select
              class="decimal-select"
              v-model="currentDepth"
              flat
              single-line
              dense
              :items="depthOptions"
              item-text="text"
              item-value="value"
              append-icon="mdi-chevron-down"
              outlined
              :menu-props="{ offsetY: true }"
              @change="depthItemClick"
            >
              <template v-slot:selection="{ item, index }">
                <span class="color-sell">{{ viewDepth }}</span>
              </template>
            </v-select>
          </div>
        </div>
        <ul id="depth-label-wrapper" class="d-flex flex-wrap depth-caption">
          <li class="caption-item">{{ $t('labels.trade.price') }}</li>
          <li class="caption-item">{{ $t('labels.trade.vol') }}</li>
          <li class="caption-item">{{ $t('labels.trade.amt') }}</li>
        </ul>
        <DepthComponent
          ref="depthSell"
          :model="model.sell"
          :reverseIndex="true"
          :label="$t('labels.trade.sell')"
          :type="'sell'"
          :labelClass="`color-sell`"
          :scrollBottomOnLoad="true"
          :onClickCallback="onDepthRowClick"
        ></DepthComponent>
        <div id="latest-price-bar">
          <span :class="!lastPrice.type ? '' : 1 == lastPrice.type ? 'color-buy' : 'color-sell'">
            {{ decimalRetain(lastPrice.price, getPrecision(1)) || '--' }} / {{ Getter_Current_Currency.abbreviation || '--' }}
            {{
            lastPrice
            ? ( decimalRetain(lastPrice.price * (Getter_Current_Currency.rate ? Getter_Current_Currency.rate : 1), getPrecision(1)))
            : '--'
            }}
          </span>
        </div>
        <DepthComponent
          ref="depthBuy"
          :model="model.buy"
          :label="$t('labels.trade.buy')"
          :type="'buy'"
          :labelClass="`color-buy`"
          :onClickCallback="onDepthRowClick"
        ></DepthComponent>
      </div>
    </div>
  </div>
</template>

<script>
import index from './depth-data';
export default index;
</script>

<style lang="stylus" scoped>
@import 'depth-data.styl';
</style>